import EmptyRouterView from '../views/layouts/EmptyRouterView'
import AppLayout from '../views/layouts/AppLayout'

export default [
  {
    path: '/settings/users',
    component: EmptyRouterView,
    meta: {
      bodyClass: 'app-page'
    },
    children: [
      {
        path: 'osda',
        name: 'settings.users.osda.index',
        component: () => import(/* webpackChunkName: "settings_users_osda_index" */ '../views/settings/users/Osda/Index.vue'),
        meta: {
          layout: AppLayout,
          pageTitle: 'บัญชีเจ้าหน้าที่สนง.กิจฯ',
          bodyClass: 'app-page'
        }
      },
      {
        path: 'osda/create',
        name: 'settings.users.osda.create',
        component: () => import(/* webpackChunkName: "settings_users_osda_create" */ '../views/settings/users/Osda/Create.vue'),
        meta: {
          layout: AppLayout,
          pageTitle: 'บัญชีเจ้าหน้าที่สนง.กิจฯ',
          bodyClass: 'app-page'
        }
      }
    ]
  }
]
